import classNames from 'classnames';
import { forwardRef, memo } from 'react';

import { Filters } from '@air/next-icons';
import { Button, type ButtonProps } from '@air/primitive-button';

import { NEW_FILTERS_BUTTON } from '~/constants/testIDs';

export type FiltersButtonProps = {
  isActive: boolean;
  filtersCount?: number;
} & ButtonProps;

const _FiltersButton = forwardRef<HTMLButtonElement, FiltersButtonProps>(
  ({ filtersCount, isActive, ...props }: FiltersButtonProps, ref) => {
    const hasFilters = !!filtersCount;

    return (
      <Button
        appearance="ghost"
        color={isActive || hasFilters ? 'blue' : 'grey'}
        className={classNames(
          'px-2.5',
          isActive || hasFilters ? 'bg-blue-3 hover:bg-blue-5 active:bg-blue-5' : undefined,
        )}
        data-testid={NEW_FILTERS_BUTTON}
        ref={ref}
        size="medium"
        suffix={
          !!filtersCount && (
            <div
              className="flex h-4 min-w-[16px] shrink-0 items-center justify-center rounded-24 bg-blue-11 px-1 text-center font-bold text-10 text-blue-1"
              data-testid="NEW_FILTERS_BUTTON_COUNT"
            >
              {filtersCount}
            </div>
          )
        }
        {...props}
      >
        <Filters className="size-4" />
      </Button>
    );
  },
);

_FiltersButton.displayName = '_FiltersButton';

export const FiltersButton = memo(_FiltersButton);

FiltersButton.displayName = 'FiltersButton';
